import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[300]};
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  padding: 16px;
  p {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 18px;
    font-weight: 500;
    line-height: 150%;
    letter-spacing: 0.15px;
    margin: 0;
    padding: 0;
  }
`;

export const Wrapper = styled.div<{ $flex: number; $distance: number }>`
  max-height: calc(100vh - ${({ $distance }) => $distance}px);
  flex: ${({ $flex }) => $flex};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  flex-direction: column;

  overflow-y: scroll;
`;

export const UnsavedChanges = styled.div`
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  display: flex;
  max-width: 300px;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 3px;
  flex-wrap: wrap;

  color: ${({ theme }) => theme.palette.grey[700]};
  font-size: 12px;
  font-weight: 500;
  margin-left: 16px;
`;
